import { ObjectID } from 'bson';
import { IServiceOrganization } from '../schemas/serviceOrganization';

/**
 * Gets the availability code from a ServiceOrganization if it has one
 */
export function getAvailabilityCode(serviceOrg: IServiceOrganization): string | undefined {
  const { selectedOption } = serviceOrg;
  if (!selectedOption) return undefined;
  return selectedOption.availabilityCode;
}

/**
 * Given an array of ServiceOrganizations it finds the unique serviceIds from them
 */
export function getUniqueServiceIds(
  serviceOrgs: Array<Pick<IServiceOrganization, 'service'>>,
): ObjectID[] {
  const uniqServiceIds: ObjectID[] = [];
  const underlyingSet = new Set();

  for (const serviceOrg of serviceOrgs) {
    const serviceId: string | ObjectID = serviceOrg.service as any;
    const serviceIdStr = serviceId.toString();
    if (!underlyingSet.has(serviceIdStr)) {
      underlyingSet.add(serviceIdStr);
      if (typeof serviceId === 'string') {
        // this is required, because sometimes, data passed from the frontend
        // ends up calling this function and then it returns an array of strings
        // which breaks the contract that this function should always return ObjectID[]
        uniqServiceIds.push(new ObjectID(serviceId));
      } else {
        uniqServiceIds.push(serviceId);
      }
    }
  }
  return uniqServiceIds;
}
